import React from "react";
import { GrClose } from "react-icons/gr";
import "./styles.scss";

interface ModalProps {
    children: JSX.Element | JSX.Element[] | string;
    isShow: boolean;
    onClickModalClose: () => void;
}

const Modal = (props: ModalProps) =>
    props.isShow && (
        <div className="modal-overlay">
            <div className="modal-wrapper">
                <div className="modal-container">
                    <div className="modal-contents">{props.children}</div>
                    <GrClose
                        className="modal-close"
                        size={18}
                        onClick={props.onClickModalClose}
                    />
                </div>
            </div>
        </div>
    );

export default Modal;
